const routes = [
    {
        name: 'listarDocumentos',
        path: '/assinatura_digital/documentos',
        alias: '/assinatura_digital/documentos/index',
        component: () => import('../views/Listar')
    },
    {
        beforeEnter: (to, from, next) => {
            if (to.query.registroId) {
                const query = { ...to.query, registro_id: to.query.registroId };
                delete query.registroId;

                next({ path: to.path, query, replace: true });
            } else {
                next();
            }
        },
        name: 'adicionarDocumento',
        path: '/assinatura_digital/documentos/adicionar',
        component: () => import('../views/Adicionar'),
        meta: {
            fullScreen: true,
            semChat: true, // o rodapé fixo do wizard ficaria embaixo do widget de suporte
        },
    },
    {
        name: 'editarDocumento',
        path: '/assinatura_digital/documentos/editar/:id',
        component: () => import('../views/Editar'),
        meta: {
            fullScreen: true,
            semChat: true,
        },
    },
    {
        name: 'visualizarDocumento',
        path: '/assinatura_digital/documentos/visualizar/:id/:abrirModal?',
        meta: {
            abrirModal: false
        },
        component: () => import('../views/Visualizar')
    },
    {
        name: 'clonarDocumento',
        path: '/assinatura_digital/documentos/clonar/:id',
        component: () => import('../views/Clonar'),
        meta: {
            fullScreen: true,
        },
    }
]

export default routes
